import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "overflow-x-auto" }
const _hoisted_3 = { class: "align-middle inline-block min-w-full" }
const _hoisted_4 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_5 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, " Lock reason "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, " Status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, " From "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, " To "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
    }, " Violatable by "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      width: "50px",
      style: {"min-width":"50px"},
      class: "px-4 py-3 text-left text-xs font-medium text-gray-500"
    }, " Actions ")
  ])
], -1)
const _hoisted_7 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "100%",
  class: "px-3 py-2 text-gray-500 text-sm"
}, "No locks found.", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_12 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_16 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_17 = { class: "px-3 py-2 border-r text-sm" }
const _hoisted_18 = { class: "px-3 py-2 flex align-middle justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShieldCheckIcon = _resolveComponent("ShieldCheckIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_ClipboardListIcon = _resolveComponent("ClipboardListIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", _hoisted_7, [
              (_ctx.locks.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _hoisted_10))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locks, (lock) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: lock.id,
                  class: "hover:bg-gray-50"
                }, [
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("span", null, _toDisplayString(lock.lockReason.name), 1)
                  ]),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["inline-flex items-center justify-center text-xs font-semibold text-center p-1 uppercase rounded-md", _ctx.isBroken(lock) ? 'text-red-600 bg-red-100' : 'text-green-600 bg-green-100'])
                    }, [
                      (_ctx.isBroken(lock))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Broken"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, "Locked"))
                    ], 2)
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(lock.dateFrom)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(lock.dateTo)), 1)
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lock.roles, (role) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: role.id,
                        class: "inline-flex items-center justify-center mr-1 text-xs font-semibold text-center p-1 uppercase rounded-md text-indigo-600 bg-indigo-100"
                      }, _toDisplayString(role.name), 1))
                    }), 128))
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    (_ctx.isBroken(lock))
                      ? (_openBlock(), _createBlock(_component_app_button, {
                          key: 0,
                          onClick: ($event: any) => (_ctx.OnClickAcceptLockViolations(lock.id)),
                          type: "blue",
                          padding: "small",
                          class: _normalizeClass(['mr-1']),
                          title: "Accept lock violations"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ShieldCheckIcon, { class: "h-5 w-5" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isBroken(lock))
                      ? (_openBlock(), _createBlock(_component_app_button, {
                          key: 1,
                          onClick: ($event: any) => (_ctx.$emit('openViolationModal', lock)),
                          type: "green",
                          padding: "small",
                          class: _normalizeClass(['mr-1']),
                          title: "Violation list"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ClipboardListIcon, { class: "h-5 w-5" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_app_button, {
                      onClick: ($event: any) => (_ctx.OnClickDeleteLock(lock.id)),
                      type: "red",
                      padding: "small",
                      class: _normalizeClass(['mr-1']),
                      title: "Delete lock"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_XIcon, { class: "h-5 w-5" })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}